module.exports = __webpack_public_path__ + "img/Picture3.b50cce08.jpg";